import { createAction } from "@reduxjs/toolkit";

export const userLoggedOut = createAction("USER_LOGGED_OUT");
